import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import ResultsModal from '../generic/ResultsModal';
import RaisedTextBox from "react/views/generic/RaisedTextBox";
import LexileSearch, {MAX_LEXILE, MIN_LEXILE} from './LexileSearch';
import TrackedLink from "react/views/generic/TrackedLink";
import LexileMeasureEventTypes from "data/types/LexileMeasureEventTypes";
import CardFooter from "../../card/CardFooter";
import LexileAdditionalInfo from './LexileAdditionalInfo';
import LinkToNoveList from 'react/views/generic/LinkToNoveList';
import Button from "react/views/generic/Button";
import CarouselSearchResults from './CarouselSearchResults';
import ReadingLevelOverview from './ReadingLevelOverview';
import ReadingLevelDetails from './ReadingLevelDetails';
import "./lexile.less";


class LexileView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchForResults: false,
			isModalOpen: false,
			showWarning: false
		};

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openChartModal = this.openChartModal.bind(this);
		this.openResultsModal = this.openResultsModal.bind(this);
		this.validateLexileSearch = this.validateLexileSearch.bind(this);
		this.setLower = this.setLower.bind(this);
		this.setUpper = this.setUpper.bind(this);
	}

	openModal() {
		this.setState({
			isModalOpen: true,
		});
	}

	closeModal() {
		this.setState({
			isModalOpen: false,
		});
	}

	openChartModal() {
		this.setState({ searchForResults: false });
		this.openModal();
	}

	openResultsModal() {
		this.props.handleSearch(this.state.lowerBound, this.state.upperBound);
		this.setState({ searchForResults: true });
		this.openModal();
	}

	validateLexileSearch() {
		if(this.isSearchRangeValid()){
			this.openResultsModal();
		}
		else {
			this.setState({showWarning: true});
		}
	}
	isSearchRangeValid() {
		return this.isValidLexileValue(this.state.upperBound)
			&& this.isValidLexileValue(this.state.lowerBound)
			&& this.state.upperBound >= this.state.lowerBound;
	}

	isValidLexileValue(value) {
		return value !== undefined
			&& value >= MIN_LEXILE
			&& value <= MAX_LEXILE;
	}

	setUpper(value){
		this.setState({ upperBound: value, showWarning: false});
	}

	setLower(value){
		this.setState({ lowerBound: value, showWarning: false});
	}

	renderSearchButton() {
		return (<TrackedLink featureType={LexileMeasureEventTypes.LEXILE_SEARCH_CLICKED} destId={this.props.loggingId} srcId={this.props.loggingId}>
			<Button onClick={this.validateLexileSearch} small>Search</Button>
		</TrackedLink>)
	}

	render() {
		this.title = "Lexile Measure";
		const shouldSearchForResults = this.state.searchForResults;

		let resultsModal;

		if (shouldSearchForResults) {
			let linkToNovelist = <LinkToNoveList
				displayText="Search for more titles by Lexile in NoveList"
				featureType={LexileMeasureEventTypes.LEXILE_NOVELIST_CLICKED}
				href={this.props.novelistLink}
				srcId=""
				destId=""
				link
			/>;

			let {lowerLexile, upperLexile} = this.props;

			let lexileResultsHeader = `BASED ON A LEXILE RANGE OF ${lowerLexile} to ${upperLexile}`;

			resultsModal = (
				<ResultsModal
					modalTitle={this.title}
					isLoading={this.props.isLoading}
					isOpen={this.state.isModalOpen}
					close={this.closeModal}
				>
					{!this.props.isLoading && <CarouselSearchResults {...this.props} {...this.state} linkToNovelist={linkToNovelist} 
						jacketClickEvent={LexileMeasureEventTypes.LEXILE_COVER_CLICKED}
						titleClickEvent={LexileMeasureEventTypes.LEXILE_TITLE_CLICKED}
						otsFindItEvent={LexileMeasureEventTypes.LEXILE_FINDIT_CLICKED}
						otsClickEvent={LexileMeasureEventTypes.LEXILE_AVAILABILITY_CLICKED}
						resultsHeader={lexileResultsHeader}
						closeModal={this.closeModal} /> }
				</ResultsModal>
			);
		} else {
			resultsModal = (
				<ResultsModal
					isOpen={this.state.isModalOpen}
					isScrollable={true}
					close={this.closeModal}
				>
					<LexileAdditionalInfo />
				</ResultsModal>
			);
		}

		return (
			<Card>
				<CardTitle title={this.title} />
				<div className="current-title-lexile">
					<ReadingLevelOverview>
						<div className="lexile-value-circle">{this.props.lexile}L</div>

						<RaisedTextBox>Lexile Measure: {this.props.lexile}</RaisedTextBox>
					</ReadingLevelOverview>
					<ReadingLevelDetails>
						<TrackedLink
							featureType={LexileMeasureEventTypes.LEXILE_VIEWCHART_CLICKED}
							destId={this.props.loggingId}
							srcId={this.props.loggingId}
						>
							<span className="clickable view-lexile-chart" onClick={this.openChartModal}>
								View Lexile info
							</span>
						</TrackedLink>

						<div className="lexile-range">
							<h3 className="lexile-title">Browse by Lexile</h3>
							<p>Find the books you'd like to read within this Lexile range</p>
						</div>
					</ReadingLevelDetails>
					<LexileSearch currentLexile={this.props.lexile}
						setUpper={this.setUpper}
						setLower={this.setLower}
						showWarning={this.state.showWarning}
					/>
					{resultsModal}
				</div>
				<CardFooter rightContent={this.renderSearchButton()}/>
			</Card>
		);
	}
}

LexileView.propTypes = {
	lexile: PropTypes.number.isRequired,
	novelistLink: PropTypes.string
};

export default LexileView;



// WEBPACK FOOTER //
// ./src/react/views/readingLevel/Lexile.jsx